// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: '/api',
  // baseUrl: 'https://localhost:62877'
  // baseUrl: 'https://cecom2-training.azurewebsites.net/services'
  // baseUrl: 'http://cecom.linkium.net:8085'
  // baseUrl: 'https://cecom2.azurewebsites.net/services'
  // baseUrl: 'http://cecom.training.linkium.net/services'
  baseUrl: 'https://cecom.cruzroja.linkium.net/services'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
